import styled from 'styled-components';

export const NeedleDetailsContainer = styled.div`
  background-color: #F4F8FF;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  padding-bottom: 48px;
`;

export const FilterWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  background: #0D2855;
  padding: 16px;
  justify-content: space-around;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
`;

export const FilterItem = styled.div`
  color: white;
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 8px;
  font-weight: 500;
`;

export const FilterIcon = styled.img`
  width: 50px;
  height: 50px;
  border-radius: 50%;
`;

export const TableContainer = styled.div`
  padding: 36px 60px;

  @media (max-width: 900px) {
    padding: 30px 40px;
  }
  
  @media (max-width: 499px) {
    padding: 12px 14px;
  }
`;

export const Table = styled.table`
  width: 100%;
  border-spacing: 0;
  border-collapse: collapse;

  @media (max-width: 768px) {
    display: block;
    overflow-x: auto;
    white-space: nowrap;
  }

  tr:last-child td:first-child {
    border-bottom-left-radius: 10px;
  }
      
  tr:last-child td:last-child {
    border-bottom-right-radius: 10px;
  }
`;

export const TableHeader = styled.tr`
  background: rgba(247, 147, 30, 0.2);

  th {
    padding: 28px;
    font-weight: 600;
  }

  th:first-child {
    border-top-left-radius: 10px;
  }
      
  th:last-child {
    border-top-right-radius: 10px;
  }
`;

export const TableRow = styled.tr<{ alt?: boolean }>`
  background: ${({ alt }) => (alt ? '#F5F8FA' : 'white')};

  td {
    padding: 28px;
  }
`;

export const TableData = styled.td<{ bold?: boolean }>`
  font-weight: ${({ bold }) => (bold ? '700' : '400')};
`;

export const CTAButton = styled.button`
  margin: 2rem auto 0;
  display: block;
  padding: 12px 24px;
  background: white;
  color: #000;
  font-weight: 600;
  font-size: 16px;
  border: 2px solid #f7941d;
  border-radius: 12px;
  cursor: pointer;
  transition: 0.2s ease;
  margin-top: 14px;

  &:hover {
    background: #f7941d;
    color: white;
  }
`;

export const LinkContainer = styled.div`
  display: flex;
  justify-content: right;
  margin-right: 40px;

  @media (max-width: 768px) {
    margin-right: 16px;
  }
`

export const CehvronContainer = styled.a`
  text-decoration: none;
  color: #000;
  background-color: white;
  height: 50px;
  width: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 36px;
  font-weight: bold;
  padding-top: 20px;
  box-sizing: border-box;

  @media (max-width: 768px) {
    height: 40px;
    width: 40px;
    font-size: 28px;
    padding-top: 16px;
  }
`
